import * as Sentry from "@sentry/react";
import React from "react";

import { FullScreenErrorPage } from "./FullScreenErrorPage";
import { useTranslation } from "react-i18next";

export function AppErrorBoundary({ children }: React.PropsWithChildren) {
  const { t } = useTranslation();

  return (
    <Sentry.ErrorBoundary
      fallback={
        <FullScreenErrorPage
          title={t("Something went wrong")}
          message={t("Please refresh the page or try again later.")}
        />
      }
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
